import { render, staticRenderFns } from "./PhotocallRegister.vue?vue&type=template&id=54459fb8&scoped=true&"
import script from "./PhotocallRegister.vue?vue&type=script&lang=js&"
export * from "./PhotocallRegister.vue?vue&type=script&lang=js&"
import style0 from "./PhotocallRegister.vue?vue&type=style&index=0&id=54459fb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54459fb8",
  null
  
)

export default component.exports